import { render, staticRenderFns } from "./znwd.vue?vue&type=template&id=b5018206&scoped=true&"
import script from "./znwd.vue?vue&type=script&lang=js&"
export * from "./znwd.vue?vue&type=script&lang=js&"
import style0 from "./znwd.vue?vue&type=style&index=0&id=b5018206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5018206",
  null
  
)

export default component.exports